import { handleActions } from 'redux-actions'
import {
  SET_ALERT_BOX,
} from '@App/constantes'
import { Alert } from './types'

interface State {
  alert?: Alert
}

const initialState: State = {}

const reducer = handleActions({
  [SET_ALERT_BOX]: (state: any, action: any) => {
    return {
      ...state,
      alert: action.payload,
    }
  },
  // tslint:disable-next-line: align
}, initialState)

export default reducer
